import React from 'react';
import SurveyResultsListLoader from './parts/SurveyResultsTableLoader';
import SurveyResultsTable from './parts/SurveyResultsTable';

function SurveyResultsList() {
  return (
    <SurveyResultsListLoader>
      <SurveyResultsTable />
    </SurveyResultsListLoader>
  );
}

export default SurveyResultsList;
